import { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import CalendarIcon from '@zvuk-b2b/react-uikit/ui/icons/Calendar';
import IconMapPin from '@zvuk-b2b/react-uikit/ui/icons/MapPin';

import { NextDateProps } from './nextDateProps';
import useNextDate from '../../model/useNextDate';

import styles from './NextDate.module.scss';

const NextDate: FC<NextDateProps> = ({ selectedPriceItemPeriodTitle }) => {
  const viewModel = useNextDate();

  if (!viewModel) {
    return <div className={styles.skeleton} />;
  }

  const { hasTrialLicenses, licensesCount, formatNextBillingDate } = viewModel;

  return (
    <>
      <div className={styles.dateAddressBlock}>
        <span>
          <CalendarIcon className={styles.icon} />
        </span>
        <span>
          {TEXTS.TOTAL_PRICE_BLOCK_FIRST_DEBITING_TEXT(hasTrialLicenses, selectedPriceItemPeriodTitle.toLowerCase())}
        </span>
        <div>{formatNextBillingDate ?? TEXTS.TOTAL_PRICE_BLOCK_FIRST_DEBITING_TEXT_FALLBACK}</div>
      </div>

      <div className={styles.dateAddressBlock}>
        <span>
          <IconMapPin className={styles.icon} />
        </span>
        <span>{TEXTS.TOTAL_PRICE_BLOCK_LICENSES_COUNT}</span>
        <div data-testid="total_price_block_licenses_count">{licensesCount}</div>
      </div>
    </>
  );
};

export default NextDate;
